import {createGlobalStyle} from 'styled-components';
import {$phone} from '~src/theme/media';

export default createGlobalStyle`
  @media ${$phone} {
    h1.ant-typography, .ant-typography h1 {
      font-size: 24px;
      line-height: 1.3;
    }
    h2.ant-typography, .ant-typography h2 {
      font-size: 20px;
      line-height: 1.3;
    }
    .ant-modal {
      top: 0;
      padding-bottom: 0;
    }
  } 
`;
